import { gql } from '@apollo/client'

export const CHANNEL_API_KEYS = gql`
  query ChannelAPIKeys($channelId: String!) {
    channelAPIKeys(channelId: $channelId) {
      description
      entityId
      entityType
      expiresAt
      key
      id
      created_at
      updated_at
    }
  }
`
